module.exports = __webpack_public_path__ + "static/media/dsc_0390.5a80263c.jpg";